import * as authActionTypes from './auth/actionTypes';
import * as userActionTypes from './users/actionTypes';
import * as roleActionTypes from './roles/actionTypes';
import * as entityActionTypes from './entities/actionTypes';
import * as sharedActionTypes from './shared/actionTypes';

export default {
    authActionTypes,
    userActionTypes,
    roleActionTypes,
    entityActionTypes,
    sharedActionTypes
}